
import React, {useState} from "react";
import "./Snapmint.css";
import './Hrone.css';
import './Medkart.css';
import './Sunsure.css'
import sunsure from '../../images/casestudies/sunsure.webp';
import a from '../../images/casestudies/sunsure-tata.webp';
import b from '../../images/casestudies/sunsure-l&t.webp';

import c from '../../images/casestudies/alkemi.webp';
import d from '../../images/casestudies/Radixcap.webp';
import e from '../../images/casestudies/sunsure-2.webp'

const FlipCard = ({ frontText, backContent }) => {
  return (
    <div className="flip-card">
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <p className="text-white ">{frontText}</p>
        </div>
        <div className="flip-card-back">
          {backContent}
        </div>
      </div>
    </div>
  );
};
const SnapmintPage = () => {
  const [activeCard, setActiveCard] = useState(1); // Track which card is open

  const toggleSection = (cardNumber) => {
    setActiveCard(activeCard === cardNumber ? null : cardNumber); // Toggle between open/close
  };

  return (
    <div className="container my-5">
      <div className="roundBorder">
      
      <h2 className="titleServ">
      Sunsure – Leading the nation's sustainable energy revolution as a premier renewable energy company
              </h2>
              <div className="lineServ mt-30"></div>
      <div className=" mt-40">
      <div className="sunsure-investor-container mt-5">
        <div>
            <img src={sunsure} />
        </div>
    
        <div className="sunsure-investors-container">
      {/* Card 1 */}
      <div className={activeCard === 1 ? "sunsure-investor-section" : "sunsure-investor-section2"}>
        <div className="investors-card">
          <div className="investors-header">
            <span className={activeCard === 1 ? "title-open" : "title-closed"}>INVESTORS</span>
            <button
              className={activeCard === 1 ? "title-open toggle-button" : "title-closed toggle-button"}
              onClick={() => toggleSection(1)}
            >
              {activeCard === 1 ? "-" : "+"}
            </button>
          </div>
          {activeCard === 1 && (
           <div className="sunsure-investors-content">
          
             
         
             <a href="https://www.tatacapital.com/">
               <img className="w-24 md:w-32 lg:w-40 hover:scale-110 transition-transform duration-300" src={a} alt="Prudential" />
             </a>
             
             <a href="https://www.ltfs.com/">
               <img className="w-24 md:w-32 lg:w-40 hover:scale-110 transition-transform duration-300" src={b} alt="Kae Capital" />
             </a>
           
         </div>
         
           
          )}
        </div>
      </div>

      {/* Card 2 */}
      <div className={activeCard === 2 ? "sunsure-investor-section21 mt-3" : "sunsure-investor-section2 mt-3"}>
        <div className="investors-card">
          <div className="investors-header">
            <span className={activeCard === 2 ? "title-open sunsure-header" : "title-closed"}>Story after association with Radix</span>
            <button
              className={activeCard === 2 ? "title-open toggle-button" : "title-closed toggle-button"}
              onClick={() => toggleSection(2)}
            >
              {activeCard === 2 ? "-" : "+"}
            </button>
          </div>
          {activeCard === 2 && (
            <div className="sunsure-investors-content2 mt-3">
              <p className="text-black  mb-2">Acquired by Partners Group in 2022 for $400M</p>

              <p className="text-black mt-4">Institutional Funding for platform play</p>
            </div>
          )}
        </div>
      </div>
    </div>

</div>

                  </div>

                 
                  <h2 className="titleServ mb-5 mt-5">
                  Low differentiation yet high conviction!

              </h2>
              <div className="lineServ mt-40"></div>
    <div className="card-container">
      <FlipCard
        frontText="2018 - What marked believed"
        backContent={
          <div className="flip-back-card">
             <div className="hrone-list-2">
                        <ul >
                        
                      
            <li>Solar EPC is <strong> commoditized market,</strong> no equity before certain scale.</li>
            <li>  People <strong>did not have positive outlook</strong>  on EPC companies for residential purpose.</li>
            
            </ul>
                </div>

          </div>
        }
      />
      <FlipCard
        frontText="Radix thesis"
        backContent={
                    <div className="hrone-list-2">
            <ul >
           
            
            <li> India’s solar rooftop market will be dominated by <strong>off-grid commercials & industrial users</strong> for cheaper energy supply.</li>
            <li>The <strong>financial impact from EPC</strong> doing well <strong>will be massive</strong> for the investors</li>
            
            </ul>
       </div>
        }
      />
      
    </div>

       
    <h2 className="titleServ snap-title2">
    Sunsure – Emulating Renew Power’s Institutional Funding
              </h2>
              <div className="lineServ mt-40"></div>
      <div className="row my-4">
        <div className="col-md-6">
          <div className="">
            <img src={e} alt="Snapmint" />
            
          </div>
        </div>
        <div className="col-md-6">
          <div className="info-box">
            <h4 className="titleServ titleServ2">Sunsure Today</h4>
            <div style={{"marginInlineStart":"160px"}} className="lineServ "></div>
            <div className="sunsure-toady-card">
            <p className=" text-black">Acquired by Partners
              </p>
          
            <p className=" text-black">Group for $400M</p>
            <p className=" text-black">In 2022</p>
            
            </div>
              
          </div>
        </div>
      </div>
      <div className="text-center my-5">
          <a href="/neewee">
            <button className="btnArrow">
              <i className="fa-solid fa-arrow-left"></i> Medkart
            </button>
          </a>
          &nbsp;&nbsp;
          <a href="/sukhhi">
            <button className="btnArrow">
             Newee <i className="fa-solid fa-arrow-right"></i>
            </button>
          </a>
        </div>
        </div>
    </div>
  );
};

export default SnapmintPage;

